(function formElement($, Drupal) {
  Drupal.behaviors.rutherfordFormElement = {
    attach(context) {
      if (_.isObject(window.bsCustomFileInput)) {
        // Annoyingly, we can't pass bsCustomFileInput a DOM element (context)
        // to restrict itself to, so it runs more times than are necessary.
        window.bsCustomFileInput.init();

        // bsCustomFileInput copies the innerText (not innerHTML) of our
        // managed file widget labels, and this results in issues like
        // LTM-1032. We run some housekeeping code of our own that splits the
        // dodgy label string at the part where it starts to repeat itself,
        // and then replaces the label with just the first part - e.g. the text
        // that precedes the repetition. We have to do this each time behaviours
        // run, as bsCustomFileInput applies itself to every custom Bootstrap
        // file upload widget on the page.
        $('.custom-file-label').each(
          function undoDuplicatedTextInLabelsCausedByBsCustomFileInput() {
            const cleanLabel = $(this)
              .text()
              .split('(required)')[0]
              .trim();

            $(this)
              .find('[data-form-label-wrapper]')
              .text(cleanLabel);
          },
        );
      }
      // Makes only 1 details accordion open at a time
      $('details.add-user-details').on('click', function(event) {
        const $this = event.currentTarget;
        $('details.add-user-details').each(function() {
          if (this !== $this) {
            $(this).removeAttr('open');
          }
        });
      });
    },
  };
})(jQuery, Drupal);
